const serializeError = (error: unknown) =>
  error instanceof Error
    ? { kind: error.name, message: error.message, stack: error.stack }
    : { message: String(error) }

export const logServerError = (
  message: string,
  error?: unknown,
  attributes?: Record<string, unknown>
) => {
  const base = {
    status: 'error',
    service: 'landingpage',
    message,
    ...(error === undefined ? {} : { error: serializeError(error) }),
  }
  try {
    console.error(JSON.stringify({ ...attributes, ...base }))
  } catch {
    console.error(JSON.stringify(base))
  }
}
